import React, {ComponentProps, Fragment, useRef} from 'react';
import b_ from 'b_';

import I18N from 'assets/i18n/brandlift-project';

import {Button, Icon, Menu} from 'client/common/components/lego';

import IconButton from '../icon-button';

import {usePopup} from './utils';

import './kebab-menu.css';

const b = b_.with('kebab-menu');

export interface KebabMenuProps {
    items: ComponentProps<typeof Menu>['items'];
    className?: string;
    view?: 'dark' | 'default' | 'dl-clear';
    buttonView?: ComponentProps<typeof Button>['view'];
    onChange: (data: string, closeMenu: () => void) => void;
    withText?: boolean;
}

export default function KebabMenu({
    items,
    view = 'default',
    buttonView = 'default',
    className = '',
    onChange,
    withText = false
}: KebabMenuProps) {
    const menuIconRef = useRef(null);

    const {popup: PopupWithMenu, toggle, close} = usePopup(menuIconRef);

    return (
        <Fragment>
            {withText ? (
                <span ref={menuIconRef} className={b('button')}>
                    <Button
                        onClick={toggle}
                        className={className}
                        view={buttonView}
                        size='m'
                        iconLeft={(classname: string) => <Icon className={classname} type='menu' />}
                    >
                        {I18N.surveyEditor.page.kebabBtn}
                    </Button>
                </span>
            ) : (
                <div className={`${b('icon')} ${className}`} ref={menuIconRef}>
                    <IconButton onClick={toggle} size='m' type='menu' view={buttonView} />
                </div>
            )}

            <PopupWithMenu className={b('popup')} view={view}>
                <Menu
                    items={items}
                    size='m'
                    view={view}
                    // @ts-ignore
                    onChange={e => onChange(e.target.value as string, close)}
                />
            </PopupWithMenu>
        </Fragment>
    );
}
